import { ISerpApiSearchResult } from "./PartLookup";
import { DefaultResponseWithData } from "./system";

export type InitialPriceEstimateStatus = "Queued" | "Running" | "Completed" | "Failed";
export type InitialPriceEstimateTrigger = "Automatic" | "Manual";

export const PENDING_ESTIMATE_STATUSES: InitialPriceEstimateStatus[] = ["Queued", "Running"];

/** The eBay search for one part category: the same listings Wilma Intelligence returns, summarised. */
export interface IInitialPriceEstimateCategory {
  partCategoryId: string;
  categoryName: string;
  searchTerm: string;
  ebayCategoryId: string | null;
  listingCount: number;
  minPrice: number | null;
  averagePrice: number | null;
  maxPrice: number | null;
  error: string | null;
  sortOrder: number;
  results: ISerpApiSearchResult[];
}

/** One run of the Initial Price Estimate for a lead. */
export interface IInitialPriceEstimate {
  id: string;
  leadId: string;
  vehicleId: string;
  status: InitialPriceEstimateStatus;
  trigger: InitialPriceEstimateTrigger;
  queuedOn: string;
  startedOn: string | null;
  completedOn: string | null;
  error: string | null;
  /** Sum of the average asking price of every priced category. */
  totalAverage: number | null;
  categoryCount: number;
  pricedCategoryCount: number;
  categories: IInitialPriceEstimateCategory[];
}

export interface IInitialPriceEstimateListResponse extends DefaultResponseWithData<IInitialPriceEstimate[]> {}
export interface IInitialPriceEstimateSingleResponse extends DefaultResponseWithData<IInitialPriceEstimate | null> {}
export interface IInitialPriceEstimateAvailability {
  enabled: boolean;
  /** Whether new leads and quotes run an estimate on their own. */
  autoLookup: boolean;
  /** Why it is not enabled, for admins working out what is missing. */
  reason: string | null;
}

export interface IInitialPriceEstimateAvailabilityResponse extends DefaultResponseWithData<IInitialPriceEstimateAvailability> {}
